import { AnimalScreeningReportVendors, VerificationStatus } from "shared/types";
import {
  OurPetPolicyAnimal,
  OurPetPolicyLandlordStatus,
  OurPetPolicyStatus
} from "./types/our-pet-policy";
import { PetScreeningAnimal, PetScreeningStatus } from "./types/pet-screening";
import { BadgeVariant } from "shared/components";

type AnimalScreeningReportAnimals = (OurPetPolicyAnimal | PetScreeningAnimal)[];

type AnimalScreeningRawResponse = {
  animals?: AnimalScreeningReportAnimals;
  pets?: AnimalScreeningReportAnimals;
};

type AnimalScreeningVerificationLike = {
  data?: {
    raw_response?: AnimalScreeningRawResponse | null;
    verification_status?: VerificationStatus | string;
  } | null;
  finished_at?: string | null;
  report?: {
    pets?: AnimalScreeningReportAnimals;
  } | null;
  status?: VerificationStatus | string;
};

export const getVerificationStatusByVendor = (
  pet: PetScreeningAnimal | OurPetPolicyAnimal,
  vendor: AnimalScreeningReportVendors
  // eslint-disable-next-line sonarjs/function-return-type -- polymorphism
): PetScreeningStatus | OurPetPolicyLandlordStatus => {
  if (vendor === AnimalScreeningReportVendors.PetScreening)
    return (pet as PetScreeningAnimal).status;
  return (pet as OurPetPolicyAnimal).verification_status;
};

export const statusBadgeVariant = (
  status: OurPetPolicyStatus | PetScreeningStatus
): BadgeVariant => {
  switch (status) {
    case OurPetPolicyStatus.PENDING:
    case PetScreeningStatus.draft:
    case PetScreeningStatus.verifying:
    case PetScreeningStatus.non_responsive:
    case PetScreeningStatus.pending:
      return BadgeVariant.WARNING;
    case OurPetPolicyStatus.APPROVED:
    case PetScreeningStatus.active:
    case PetScreeningStatus.recommended:
    case PetScreeningStatus.conditionally_recommended:
      return BadgeVariant.SUCCESS;
    case OurPetPolicyStatus.NOT_APPROVED:
    case PetScreeningStatus.declined:
    case PetScreeningStatus.expired:
    case PetScreeningStatus.returned:
      return BadgeVariant.ERROR;
    default:
      return BadgeVariant.BASE;
  }
};

export const getAnimalScreeningRawResponseAnimals = (
  verification?: AnimalScreeningVerificationLike | null
) => {
  const rawResponse = verification?.data?.raw_response;

  return rawResponse?.pets?.length ? rawResponse.pets : rawResponse?.animals;
};

export const hasCompletedAnimalScreeningReport = (
  verification?: AnimalScreeningVerificationLike | null
) => {
  const rawResponseAnimals = getAnimalScreeningRawResponseAnimals(verification);

  return Boolean(
    verification?.status === VerificationStatus.Finished ||
    verification?.status === VerificationStatus.Completed ||
    verification?.finished_at ||
    verification?.data?.verification_status === VerificationStatus.Completed ||
    verification?.report?.pets?.length ||
    rawResponseAnimals?.length
  );
};
